import { createActionFactory } from '../../common/redux';

const { createAction, createApiFailureAction } = createActionFactory('Blacklist => ');

const updateBlacklist = createAction('update blacklist dictionary value', blacklistDictionary => ({
  blacklistDictionary,
}));

const bootstrapBlacklist = createAction('set the blacklist dictionary for the first time', blacklist => blacklist);

const saveBlacklist = createAction('try save blacklist changes');
const saveBlacklistSuccess = createAction('success save blacklist changes', blacklist => blacklist);
const saveBlacklistFailure = createApiFailureAction('failure save blacklist changes', error => ({ error }));

export default {
  bootstrapBlacklist,

  updateBlacklist,

  saveBlacklist,
  saveBlacklistSuccess,
  saveBlacklistFailure,
};
